
import { Action } from "@ngrx/store";
import { CategoryInterface } from "../dataLayer/HomeModels/category.interface";
import { SignInInterface } from "../dataLayer/interfaces/auth.interface";
import { CartItemInterface, CartUpdateInterface, RequestCartItemInterface } from "../dataLayer/ProductsModels/Entities/product.model";
import { OrderTaxDelieveryInterface, wallet_interface } from "../Services/ProfileService/profile.interface";
import * as types from "./constants/app.constant";
import { BrandsModel, HomeCategoryModel, SlidersModel, SpecialSectionsModel, SubCategoriesModel, credit_inteface, paymob_order_interface } from "./constants/app.models";




// actions


export class update_app_loader_action implements Action
{

   readonly type: string = types.update_app_loader;
   constructor(public data: boolean){}

}



export class GET_CATEGORIES_ACTION implements Action
{

   readonly type: string = types.GET_CATEGORIES;
   constructor(){}

}


export class CATEGORIES_LOADED_ACTION implements Action
{

   readonly type: string = types.CATEGORIES_LOADED;
   constructor( public data: CategoryInterface[] ){}

}




export class SET_HOME_BRAND_ID_ACTION implements Action
{

   readonly type: string = types.SET_HOME_BRAND_ID;
   constructor(public data: number){}

}



// Cart

export class UPDATE_CART_DISPLAY_STATUS_ACTION implements Action
{

   readonly type: string = types.update_cart_display_status;
   constructor( public data: boolean ){}

}


export class UPDATE_AUTH_MODAL_DISPLAY_STATUS_ACTION implements Action
{

   readonly type: string = types.update_auth_modal_display_status;
   constructor( public data: boolean ){}

}

export class UPDATE_ADD_ADDRESS_MODAL_DISPLAY_STATUS_ACTION implements Action
{

   readonly type: string = types.update_add_address_modal_display_status;
   constructor( public data: boolean ){}

}















// Auth

export class SIGN_IN_ACTION implements Action
{

   readonly type: string = types.SIGN_IN;
   constructor( public data: SignInInterface ){}

}


export class SIGN_OUT_ACTION implements Action
{

   readonly type: string = types.SIGN_OUT;
   constructor(){}

}


export class SHOW_HEADER_CART_ACTION implements Action
{

   readonly type: string = types.show_header_cart;
   constructor( public data: boolean ){}

}



// MAP
export class SET_ACTIVE_LOCATION_ACTION implements Action
{

   readonly type: string = types.set_active_location;
   constructor( public data: any ){}

}





export class SET_ORDER_TAX_DELIEVERY_ACTION implements Action
{

   readonly type: string = types.SET_ORDER_TAX_DELIEVERY;
   constructor( public data: OrderTaxDelieveryInterface ){}

}


export class Toggle_Wallet_Display_Status_ACTION implements Action
{

   readonly type: string = types.Toggle_Wallet_Display_Status;
   constructor( public data: boolean ){}

}



// general

export class SET_REDIRECT_ACTION implements Action
{

   readonly type: string = types.SET_REDIRECT;
   constructor( public data: string ){}

}




export class GET_USER_WALLETS_ACTION implements Action
{

   readonly type: string = types.GET_USER_WALLETS;
   constructor(){}

}


export class SET_USER_WALLETS_ACTION implements Action
{

   readonly type: string = types.SET_USER_WALLETS;
   constructor(public data: wallet_interface[]){}

}


export class GET_USER_CREDIT_ACTION implements Action
{

   readonly type: string = types.GET_USER_CREDIT;
   constructor(){}

}


export class SET_USER_CREDIT_ACTION implements Action
{

   readonly type: string = types.SET_USER_CREDIT;
   constructor(public data: credit_inteface){}

}


export class request_paymob_iframe_action implements Action
{

   readonly type: string = types.request_paymob_iframe;
   constructor(){}

}


export class get_paymob_iframe_action implements Action
{

   readonly type: string = types.get_paymob_iframe;
   constructor(public data: paymob_order_interface){}

}


export class set_delivery_type_action implements Action
{
   readonly type: string = types.set_delivery_type;
   constructor(public data: 'delivery' | 'takeaway'){}
}



export class set_website_attributes_action implements Action
{
   readonly type: string = types.set_website_attributes;
   constructor(public data: any){}
}


export class GetSliders implements Action {
   readonly type = types.GetSliders;
   constructor() { }
}
export class SlidersLoaded implements Action {
   readonly type = types.SlidersLoaded;
   constructor(public data: SlidersModel) { }
}


export class GetSubCategories implements Action {
   readonly type = types.GetSubCategories;
   constructor() { }
}
export class SubCategoriesLoaded implements Action {
   readonly type = types.SubCategoriesLoaded;
   constructor(public data: SubCategoriesModel) { }
}


export class GetHotDealsData implements Action {
   readonly type = types.GetHotDealsData;
   constructor() { }
}
export class HotDealsDataLoaded implements Action {
   readonly type = types.HotDealsDataLoaded;
   constructor(public data: SpecialSectionsModel[]) { }
}


export class GetCategoriesData implements Action {
   readonly type = types.GetCategoriesata;
   constructor() { }
}
export class CategoriesLoaded implements Action {
   readonly type = types.CategoriesLoaded;
   constructor(public data: HomeCategoryModel) { }
}


export class BrandsLoaded implements Action {
   readonly type = types.BrandsLoaded;
   constructor(public data: BrandsModel) { }
}



export type ActionsUnion = GET_CATEGORIES_ACTION & CATEGORIES_LOADED_ACTION;
